import React from 'react';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import I18n from 'i18n-js';
import ShieldIcon from '@reverbdotcom/cadence/images/brand/protection-orange.svg';
import SpeakerIcon from '@reverbdotcom/cadence/images/brand/report-orange.svg';
import HelpCard from '../discovery/help_card';
import { useHelpCenterArticleUrl } from '@reverbdotcom/commons/src/url_helpers';
import {
  PREVIOUS_YEAR_TAX_REPORTING_REQUIREMENTS_ARTICLE_ID,
  UPCOMING_YEAR_TAX_REPORTING_REQUIREMENTS_ARTICLE_ID,
} from './tax_profile_helpers';

export function TaxProfileFooter() {
  const previousYearReportingArticleUrl = useHelpCenterArticleUrl(PREVIOUS_YEAR_TAX_REPORTING_REQUIREMENTS_ARTICLE_ID);
  const upcomingYearReportingArticleUrl = useHelpCenterArticleUrl(UPCOMING_YEAR_TAX_REPORTING_REQUIREMENTS_ARTICLE_ID);

  return (
    <div className="g-container .g-container--cycle">
      <div className="g-col-6 pt-5 g-col-mobile-12 mobile-mb-2">
        <HelpCard
          svgIcon={ShieldIcon}
          iconAlt={I18n.t('discovery.taxProfile.footer.shieldAlt')}
        >
          <p className="weight-bold">
            <Translate
              text="discovery.taxProfile.footer.doINeedToProvideInfoHeader"
            />
          </p>
          <Translate
            tag="p"
            text="discovery.taxProfile.footer.doINeedToProvideInfoParagraph1"
          >
            <a href={previousYearReportingArticleUrl} className="text-link">
              <Translate text="discovery.taxProfile.footer.doINeedToProvideInfoLearnMore1" />
            </a>
          </Translate>
          <Translate
            tag="p"
            text="discovery.taxProfile.footer.doINeedToProvideInfoParagraph2"
          >
            <a href={upcomingYearReportingArticleUrl} className="text-link">
              <Translate text="discovery.taxProfile.footer.doINeedToProvideInfoLearnMore2" />
            </a>
          </Translate>
          <Translate
            tag="p"
            text="discovery.taxProfile.footer.doINeedToProvideInfoParagraph3"
          />
        </HelpCard>
      </div>
      <div className="g-col-6 pt-5 g-col-mobile-12">
        <HelpCard
          svgIcon={SpeakerIcon}
          iconAlt={I18n.t('discovery.taxProfile.footer.speakerAlt')}
        >
          <p className="weight-bold">
            <Translate
              text="discovery.taxProfile.footer.advocacyHeadline"
            />
          </p>
          <Translate
            tag="p"
            text="discovery.taxProfile.footer.advocacyParagraph1"
          >
            <a href="https://www.irs.gov/newsroom/irs-announces-delay-for-implementation-of-600-reporting-threshold-for-third-party-payment-platforms-forms-1099-k" className="text-link">
              <Translate text="discovery.taxProfile.footer.advocacyOneYearDelayLink" />
            </a>
          </Translate>
          <Translate
            tag="p"
            text="discovery.taxProfile.footer.advocacyParagraph2"
          />
          <Translate
            tag="p"
            text="discovery.taxProfile.footer.advocacyParagraph3"
          >
            <a href={upcomingYearReportingArticleUrl} className="text-link">
              <Translate text="discovery.taxProfile.footer.advocacyThresholdOnHold" />
            </a>
          </Translate>
        </HelpCard>
      </div>
    </div>
  );
}

export default TaxProfileFooter;
